import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from "react-dom";
import backendApi from "../../../utils/BackendApi.js";
import { useTranslation } from 'react-i18next';
import iconInfo from "../../../../img/icon_info.svg";
import uploadIcon from '../../../../img/upload-file.svg';
import { Tooltip } from 'react-tooltip'
import { FaSpinner } from 'react-icons/fa';
import {toast } from 'react-toastify';
import iconDocSendPdf from "../../../../img/icon_doc_send-pdf.svg";
import iconCheck from "../../../../img/icon_check.svg";
import { useLocation, useNavigate } from "react-router-dom";
import iconRefresh from "../../../../img/icon_refresh.svg";
import iconDocPdf from "../../../../img/icon_doc-pdf.svg";
import { FaUserCheck, FaStickyNote, FaTimes } from 'react-icons/fa';
import { FiMessageSquare } from "react-icons/fi";


function DesignRequestsPage() {
  const [t] = useTranslation("global");
  const [designRequests, setDesignRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [sendingIndex, setSendingIndex] = useState(null);
  const [cadLoadingIndex, setCadLoadingIndex] = useState(null);
  const location = useLocation();
  const clientDms = location.state?.clientDms || "N/A";
  const [pdfLoadingIndex, setPdfLoadingIndex] = useState(null);
  const [generateLoadingIndex, setGenerateLoadingIndex] = useState(null);
  const [sendLoadingIndex, setSendLoadingIndex] = useState(null);
  const [downloadLoadingIndex, setDownloadLoadingIndex] = useState(null);
  const [designList, setDesignList] = useState([]);
  const designListRef = useRef(designList);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [openNotesIndex, setOpenNotesIndex] = useState(null);
  const [notesDraft, setNotesDraft] = useState("");
  const [savingNotes, setSavingNotes] = useState(false);
  const [menuState, setMenuState] = useState(null);
  const [includeNotConcluded, setIncludeNotConcluded] = useState(false);
  const [savingNotConcluded, setSavingNotConcluded] = useState(false);
  const requestsFetchRef = useRef(0);


//  const pathToCadPage = "https://design.domino-design.it/project/";
  const pathToCadPage = "https://design.domino-design.it/design/";

  // =========================
  // FETCH PAGINATO
  // =========================
  const fetchRequests = async (pageNumber = 0, include = includeNotConcluded) => {
    const requestId = ++requestsFetchRef.current;
    try {
      setLoading(true);
      setMenuState(null);
      setOpenNotesIndex(null);

      const res = await backendApi.get(
        `/api/design-requests?status=PENDING&page=${pageNumber}&size=10&includeNotConcluded=${include}`
      );

      if (requestId !== requestsFetchRef.current) return;
      // Se l'ultima riga viene nascosta, torna all'ultima pagina disponibile.
      const lastPage = Math.max(0, res.data.totalPages - 1);
      if (pageNumber > lastPage) {
        await fetchRequests(lastPage, include);
        return;
      }
      setDesignRequests(res.data.content);
      setTotalPages(res.data.totalPages);
      setPage(res.data.number);

    } catch (err) {
      if (requestId !== requestsFetchRef.current) return;
      console.error("Error loading design requests", err);
      toast.error("Errore nel caricamento delle richieste di preventivo");
    } finally {
      if (requestId === requestsFetchRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests(0);
  }, []);

  useEffect(() => {
    if (!menuState) return;

    const handleClickOutside = (e) => {
      setMenuState(null);
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setMenuState(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [menuState]);

  const handleCreateQuote = async (designId) => {
    try {
      await backendApi.post(`/api/design-requests/${designId}/create-quote`);
      alert(`Quote request created for design ID: ${designId}`);
    } catch (err) {
      console.error("Error creating quote", err);
      alert("Failed to create quote.");
    }
  };

  const sendQuotationToBackend = async (item, index) => {
    if (!item.dmsClientId || item.dmsClientId === "N/A") {
      toast.error("Il cliente non esiste nel DMS.");
      return;
    }

    try {
      const response = await backendApi.post("/api/multitenant/design/sendQuotation", {
        url: item.id?.url,
        negotiation_id: item.id?.negotiationId,
        design_id: item.id?.designId,
        dmsClientId: item.dmsClientId,
      });

      console.log("Quotation creation response:", response.data);
      await fetchRequests(); // aggiorna la lista
    } catch (error) {
      console.error("Error sending quotation:", error);
    }
  };


  const updateDesignRequests = () => {
    fetchRequests();
  };

  const toggleNotConcluded = async (req) => {
    if (!req || savingNotConcluded) return;
    const notConcluded = !req.notConcluded;
    setSavingNotConcluded(true);
    setMenuState(null);
    try {
      await backendApi.post("/api/design-requests/not-concluded", {
        url: req.id?.url,
        negotiationId: req.id?.negotiationId,
        designId: req.id?.designId,
        notConcluded
      });
      toast.success(notConcluded ? "Preventivo segnato come non concluso" : "Richiesta riattivata");
      await fetchRequests(page);
    } catch (err) {
      console.error("Errore aggiornamento richiesta", err);
      toast.error("Impossibile aggiornare la richiesta di preventivo");
    } finally {
      setSavingNotConcluded(false);
    }
  };

  const showErrorFun = (message) => {
    toast.error(message);
  };

  function formatDateTime(date) {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  // Funzione per verificare se l'estensione è installata e impostare i cookie
    const handleCheckAndSetCookie = (username, branchId, index) => {
      let responded = false;
      setCadLoadingIndex(index); // Imposta loading
      console.log("handleCheckAndSetCookie",username, branchId);

      const listener = (event) => {
        console.log("listener: "+JSON.stringify(event));
        if (event.data.action === "extension_status") {
          //console.log("L'estensione ha risposto");
          responded = true; // Segnaliamo che l'estensione ha risposto
          if (!event.data.installed) {
            showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
            setCadLoadingIndex(null);
          } else {
            setCookie(username, branchId); // Se l'estensione è installata, imposta i cookie
          }
          window.removeEventListener("message", listener);
        }
      };

      window.addEventListener("message", listener);
      window.postMessage({ action: "check_extension" }, "*");

      // Timeout se non riceviamo risposta in 3 secondi
      setTimeout(() => {
        console.log("Timeout: "+JSON.stringify(responded))
        if (!responded) {
          showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
          window.removeEventListener("message", listener);
          setCadLoadingIndex(null);
        }
      }, 3000);
    };

    // Funzione per invocare l'API e settare i cookie
    const setCookie = async (username, branchId) => {
      try {
          if (!username) {
            showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
            setCadLoadingIndex(null);
            return;
          }

        const response = await backendApi.get("api/set-cookie?username="+encodeURIComponent(username));

        if (response.status !== 200) {
          throw new Error("Errors on cookies!");
          //ti dovrebbe buttare fuori
        }

        const cookies = response.data;
        console.log("Cookie ricevuti dal backend:", cookies);

        if (!Array.isArray(cookies) || cookies.length === 0) {
          showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
          setCadLoadingIndex(null);
          return;
        }

        // Itera sui cookie ricevuti e li invia all'estensione
        cookies.forEach((cookie) => {
          window.postMessage(
            {
              action: "setCookie",
              cookieDetails: {
                url: "https://productionbackend.infurnia.com", // Imposta l'URL usando il dominio del cookie
                name: cookie.name,
                value: cookie.value,
                domain: cookie.domain,
                path: cookie.path,
                expires: cookie.expires, // Assumendo che sia già un numero (timestamp Unix)
                secure: cookie.secure,
                httpOnly: cookie.httpOnly,
                sameSite: cookie.sameSite,
              },
            },
            "*"
          );
        });

        // ✅ Apro il CAD solo dopo che i cookie sono stati inviati all'estensione
        if (branchId) {
          window.open(pathToCadPage + branchId, "_blank");
        }

      } catch (error) {
        console.error("Errore:", error);
        showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
      }finally {
           setCadLoadingIndex(null);
         }
    };

    const sendAllPdfs = async (item, index) => {
        setPdfLoadingIndex(index); // parte loading
//            item.dmsClientId=633;
//            item.cadId="ce84ba06c2d014d8";
        console.log("cadIdDesign: " + item.cadId);
            console.log("clientDms: " + item.dmsClientId);
        if (!item.cadId) {
            toast.error("CAD ID non disponibile, impossibile inviare i PDF.");
            return;
        }

        if (item.dmsClientId === "N/A") {
            toast.error("Il cliente non esiste nel DMS.");
            return; // 🔹 stoppo qui
        }

        try {
            const response = await backendApi.get(
                "api/design/sendAllPdfs?cadId=" + item.cadId + "&idCliente=" + item.dmsClientId
            );
            toast.success(response.data);
            await fetchRequests();
            } catch (error) {
                    console.error("Errore invio PDF:", error);

                    const status = error.response?.status;
                    const message = error.response?.data || "Errore durante l'invio dei PDF al DMS.";

                    if (status === 409) {
                        toast.info(message); // "PDF già inviati al DMS."
                    } else if (status === 400) {
                        toast.warning(message); // Parametri mancanti (es. cadId)
                    } else {
                        toast.error(message); // Errore generico o 500
                    }
                }finally {
                     setPdfLoadingIndex(null); // stop loading
                   }
    };

    const generateQuotationForDesign = async (req, index, fileType = "pdf") => {
      setSendingIndex(index);

      const requestDto = {
        negId: parseInt(req.id?.negotiationId),
        desId: parseInt(req.id?.designId),
        lang: t("lng"),
        returnType: fileType
      };

      try {
        let fileGenerated = false;

        while (!fileGenerated) {
          const response = await backendApi.get("api/quotation", {
            params: requestDto,
            responseType: "arraybuffer"
          });

          const file = response.data;

          if (file && file.byteLength > 0) {
            // Aggiorna lo stato in maniera immutabile
            setDesignRequests(prev => {
              const newArr = [...prev];
              newArr[index] = {
                ...newArr[index],
                quotationDocument: "PDF" // segnala che il PDF è generato
              };
              return newArr;
            });

            fileGenerated = true; // esci dal loop
          } else {
            // attende 5 secondi prima di riprovare
            await sleep(5000);
          }
        }
      } catch (err) {
        console.error("Errore generazione preventivo:", err);
      } finally {
        // Reset dello spinner solo dopo aver impostato lo stato corretto
        setSendingIndex(null);
      }
    };

    const downloadQuotationFile = async (idNegotiation, idDesign, url, idx, fileType) => {

        const baseDto = {
            negId: parseInt(idNegotiation),
            desId: parseInt(idDesign),
            lang: t("lng"),
            tenant: url,
        };

        try {
            //
            // 1️⃣ PRIMA CHIAMATA — returnType="none" → genera il PDF sul server
            //
            let generationReady = false;
            while (!generationReady) {
                const genResponse = await backendApi.get("api/quotation", {
                    params: { ...baseDto, returnType: "none" },
                    responseType: "arraybuffer"
                });

                const file = genResponse.data;
                // Se il BE ritorna un errore sotto forma di file vuoto → errore
                if (file && file.byteLength === 0) {
                    toast.error("Errore nella generazione del preventivo (file vuoto).");
                    return;
                }
                if (file && file.byteLength > 0) {
                    generationReady = true;
                } else {
                    await sleep(5000);
                }
            }

            //
            // 2️⃣ SECONDA CHIAMATA — returnType="pdf" → scarica il file
            //
            const pdfResponse = await backendApi.get("api/quotation", {
                params: { ...baseDto, returnType: "pdf" },
                responseType: "arraybuffer"
            });

            const file = pdfResponse.data;

            // CHECK: file vuoto = 0 KB → errore
            if (!file || file.byteLength === 0) {
                toast.error("Il file generato è vuoto (0 KB). Impossibile procedere.");
                return;
            }

            let fileName = "quotation.pdf";
            if (pdfResponse.headers["filename"]) {
                fileName = pdfResponse.headers["filename"];
            }

            downloadFile(pdfResponse.data, fileName);
            toast.success("Preventivo generato e scaricato correttamente!");

        } catch (err) {
            console.error("Errore:", err);
            toast.error("Errore durante la generazione del preventivo.");
        }
    };

    const takeInCharge = async (req, index) => {

      try {

        const assignedUsername =
          localStorage.getItem("agentFullName");

        const response = await backendApi.post(
          "/api/design-requests/take-in-charge",
          {
            url: req.id?.url,
            negotiationId: req.id?.negotiationId,
            designId: req.id?.designId,
            assignedUsername
          }
        );

        const updated = response.data;

        setDesignRequests(prev => {
          const arr = [...prev];
          arr[index] = updated;
          return arr;
        });

        toast.success("Presa in carico effettuata");

      } catch (e) {
        console.error(e);
        if (e.response?.status === 409) {
            toast.warning(e.response.data.message || "Già preso in carico");
            return;
          }

          toast.error(
            e.response?.data?.message ||
            "Errore durante la presa in carico"
          );
      }
    };

    const releaseTakeCharge = async (req, index) => {

      try {

        const response = await backendApi.post(
          "/api/design-requests/release-take-in-charge",
          null,
          {
            params: {
              url: req.id?.url,
              negotiationId: req.id?.negotiationId,
              designId: req.id?.designId
            }
          }
        );

        const updated = response.data;

        setDesignRequests(prev => {
          const arr = [...prev];
          arr[index] = updated;
          return arr;
        });

        toast.success("Presa in carico annullata");

      } catch (e) {
        console.error(e);
        toast.error("Errore durante il rilascio");
      }
    };

    const saveNotes = async (req, index) => {

      setSavingNotes(true);

      try {

        const response = await backendApi.post(
          "/api/design-requests/internal-notes",
          {
            url: req.id?.url,
            negotiationId: req.id?.negotiationId,
            designId: req.id?.designId,
            internalNotes: notesDraft
          }
        );

        const updated = response.data;

        setDesignRequests(prev => {
          const arr = [...prev];
          arr[index] = updated;
          return arr;
        });

        toast.success("Note salvate");

        setOpenNotesIndex(null);

      } catch (e) {

        console.error(e);
        toast.error("Errore salvataggio note");

      } finally {

        setSavingNotes(false);
      }
    };

    const renderAssignedDot = (req) => {
      if (!req.assignedUsername) return null;

      const formattedDate = req.assignedAt
          ? new Date(req.assignedAt).toLocaleString()
          : "";

      return (
        <span
          className="assigned-dot"
          title={`${req.assignedUsername}` +
                 `${formattedDate ? `\nAssegnato il: ${formattedDate}` : ""}`}
        />
      );
    };


   // Definizione della funzione sleep()
   const sleep = (ms) => {
       return new Promise(resolve => setTimeout(resolve, ms));
   };

   const downloadFile = (data, fileName) => {

           const blob = new Blob([data], {
               type: fileName.endsWith("pdf")
                   ? 'application/pdf'
                   : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
           });

           const url = window.URL.createObjectURL(blob);
           const a = document.createElement('a');
           a.href = url;
           a.download = fileName;
           document.body.appendChild(a);
           a.click();
           document.body.removeChild(a);
           window.URL.revokeObjectURL(url);
           console.log("Download del file completato: " + fileName);

       }

       const getPagination = (current, total) => {
         const delta = 2; // quante pagine attorno alla corrente

         const range = [];
         const rangeWithDots = [];

         let l;

         for (let i = 1; i <= total; i++) {
           if (
             i === 1 ||
             i === total ||
             (i >= current + 1 - delta && i <= current + 1 + delta)
           ) {
             range.push(i);
           }
         }

         for (let i of range) {
           if (l) {
             if (i - l === 2) {
               rangeWithDots.push(l + 1);
             } else if (i - l !== 1) {
               rangeWithDots.push("...");
             }
           }
           rangeWithDots.push(i);
           l = i;
         }

         return rangeWithDots;
       };

       const goPrev = () => { if (page > 0) fetchRequests(page - 1); };
       const goNext = () => { if (page + 1 < totalPages) fetchRequests(page + 1); };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="private-page design-requests">

      {/* HEADER */}
      <div className="row-actions">
        <h2><b>{t("agentNavBar.designRequests")}</b></h2>
      </div>

      {/* REFRESH */}
      <div className="header-quotations">
        <h4 className="m0"><b>{t("agentNegotiationDetailsPage.quotations")}</b></h4>

        <button className="toast_onpage small" onClick={updateDesignRequests}>
          <img src={iconInfo} />
          {t("agentNegotiationDetailsPage.toastUpdateList")}
        </button>
      </div>

      <label className="design-requests-filter">
        <input
          type="checkbox"
          checked={includeNotConcluded}
          disabled={savingNotConcluded}
          onChange={(event) => {
            const include = event.target.checked;
            setIncludeNotConcluded(include);
            fetchRequests(0, include);
          }}
        />
        Mostra anche i non conclusi
      </label>

      {/* TABLE */}
      <table className="private-table">
        <thead>
          <tr>
            <th></th>
            <th>{t("designRequestsPage.type")}</th>
            <th>{t("designRequestsPage.username")}</th>
            <th>ID</th>
            <th>{t("designRequestsPage.clientID")}</th>
            <th>{t("designRequestsPage.negotiationId")}</th>
            <th>{t("designRequestsPage.DesignId")}</th>
            <th>{t("designRequestsPage.negotiationTitle")}</th>
            <th>{t("designRequestsPage.designName")}</th>
            <th>{t("designRequestsPage.createdAt")}</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {designRequests.length === 0 && (
            <tr>
              <td colSpan={14} className="design-requests-empty">
                {includeNotConcluded ? "Nessuna richiesta di preventivo presente." : "Nessuna richiesta di preventivo da lavorare."}
              </td>
            </tr>
          )}
          {designRequests.map((req, index) => (
            <tr key={index}>
              <td className="table-cell-action action">
                 <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start"
                  }}>
                    <div
                        className="action-wrapper"
                        ref={(el) => (window.__menuRefs = window.__menuRefs || {})[index] = el}
                      >
                      {/* TRIGGER MENU */}
                      <button
                        className="dots-btn"
                        aria-label={`Azioni richiesta ${req.id?.negotiationId}/${req.id?.designId}`}
                        disabled={savingNotConcluded}
                        onClick={(e) => {
                          e.stopPropagation();

                          const rect = e.currentTarget.getBoundingClientRect();

                          setMenuState({
                            index,
                            x: rect.right,
                            y: rect.bottom
                          });
                        }}
                      >
                        ⋮
                      </button>
                    </div>
                    {/* STATUS ICONS */}
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>

                      {/* DOT PRESA IN CARICO */}
                      {renderAssignedDot(req)}

                      {/* NOTE ICON */}
                      {req.internalNotes && (
                        <span
                          title={req.internalNotes}
                          style={{ display: "flex", alignItems: "center", cursor: "help" }}
                        >
                          <FiMessageSquare size={13} />
                        </span>
                      )}

                    </div>
                </div>
              </td>
              <td>{req.type}</td>
              <td>{req.username}</td>
              <td
                data-tooltip-id={`tooltip-client-${index}`}
                data-tooltip-content={req.clientName || "-"}
                data-tooltip-delay-show={500}
              >
                {req.partnerId || "-"}
                <Tooltip className="tooltip" id={`tooltip-client-${index}`} place="bottom" />
              </td>
              <td>{req.dmsClientId}</td>
              <td>{req.id?.negotiationId}</td>
              <td>{req.id?.designId}</td>
              <td>{req.negotiationTitle}</td>
              <td>
                {req.designName}
                {req.notConcluded && (
                  <span className="design-request-not-concluded">Non concluso</span>
                )}
              </td>
              <td>{formatDateTime(new Date(req.createdAt))}</td>
              <td className="table-cell-action action">
                {/*<button
                  className="icon-button-round"
                  onClick={() => handleCreateQuote(req.design_id)}
                  data-tooltip-id="tooltipCreate"
                  data-tooltip-content={t("agentNegotiationDetailsPage.createQuotation")}
                  data-tooltip-delay-show={500}
                >
                  <img width={28} height={28} src={uploadIcon} />
                  <Tooltip className="tooltip" id="tooltipCreate" place="bottom" />
                </button>*/}
                {/* AZIONI QUOTAZIONE: genera PDF + invia al DMS */}
                {/* === BOTTONE 1 — GENERA PDF === */}
                <button
                    className="icon-button-round"
                    data-tooltip-id="tooltipDownload"
                    data-tooltip-content="Scarica pdf"
                    data-tooltip-delay-show={500}
                    onClick={async () => {
                      if (downloadLoadingIndex === index) return;
                      setDownloadLoadingIndex(index);
                      try {
                        await downloadQuotationFile(req.id?.negotiationId, req.id?.designId, req.id?.url, index, "pdf");
                      } finally {
                        setDownloadLoadingIndex(null);
                      }
                    }}
                    disabled={downloadLoadingIndex === index}
                    style={{
                      cursor: downloadLoadingIndex === index ? "not-allowed" : "pointer",
                      opacity: downloadLoadingIndex === index ? 0.6 : 1
                    }}
                  >
                    {downloadLoadingIndex === index ? (
                      <FaSpinner className="spinner" size={28} />
                    ) : (
                      <img width={28} height={28} src={iconDocPdf} />
                    )}
                    <Tooltip className="tooltip" id="tooltipDownload" place="bottom" />
                  </button>

                  {/* === BOTTONE 2 — INVIA PREVENTIVO AL DMS === */}
                  {req.quotationDocument ? (
                    // ✅ PREVENTIVO GIÀ CREATO
                    <img
                      src={iconCheck}
                      width={28}
                      height={28}
                      title={`Preventivo creato: ${req.quotationDocument}`}
                      alt="Preventivo creato"
                        style={{
                          filter: "invert(29%) sepia(92%) saturate(1786%) hue-rotate(97deg) brightness(95%) contrast(95%)"
                        }}
                    />
                  ) : (
                    // ❌ PREVENTIVO NON ESISTE
                    <button
                      className="icon-button-round"
                      data-tooltip-id={`tooltipSubmit-${index}`}
                      data-tooltip-content="Invia preventivo al DMS"
                      onClick={async () => {
                        if (sendLoadingIndex === index) return;
                        setSendLoadingIndex(index);
                        try {
                          await sendQuotationToBackend(req, index);
                        } finally {
                          setSendLoadingIndex(null);
                        }
                      }}
                    >
                      {sendLoadingIndex === index ? (
                        <FaSpinner className="spinner" size={28} />
                      ) : (
                        <img width={28} height={28} src={uploadIcon} />
                      )}
                    </button>
                  )}
              </td>
              <td>{req.quotationDocument}</td>
              <td>
                {/* Bottone: Vai al CAD */}
                <button
                  className="btn-cad"
                  onClick={() => handleCheckAndSetCookie(req.username, req.branchId, index)}
                    disabled={!req.branchId || cadLoadingIndex === index}
                    title={!req.branchId ? "Design CAD non disponibile" : "Apri design nel CAD"}
                      style={{
                        cursor: !req.branchId || cadLoadingIndex === index ? 'not-allowed' : 'pointer',
                        opacity: !req.branchId || cadLoadingIndex === index ? 0.6 : 1,
                      }}
                    >
                  {cadLoadingIndex === index ? (
                    <FaSpinner className="spinner" size={28} />
                  ) : (
                    <span>CAD</span>
                  )}

                </button>
                {!req.branchId && (
                  <span role="status" className="d-block text-warning small">
                    Design CAD non disponibile
                  </span>
                )}
              </td>

              <td className="table-cell-action action">
                <button
                  className="icon-button-round"
                  data-tooltip-id={`tooltipSendPdf-${req.id}`}
                  data-tooltip-content="Invia i pdf al DMS"
                  data-tooltip-delay-show={500}
                  onClick={() => sendAllPdfs(req, index)}
                  disabled={pdfLoadingIndex === index}
                  style={{
                    cursor: pdfLoadingIndex === index ? "not-allowed" : "pointer",
                    opacity: pdfLoadingIndex === index ? 0.6 : 1,
                  }}
                >
                  {pdfLoadingIndex === index ? (
                    <FaSpinner className="spinner" size={28} />
                  ) : (
                    <img
                      width={28}
                      height={28}
                      src={iconDocSendPdf}
                      alt="Invia PDF al DMS"
                    />
                  )}
                  <Tooltip className="tooltip" id={`tooltipSendPdf-${req.id}`} place="bottom" />
                </button>
              </td>

            </tr>
          ))}
        </tbody>
      </table>

      {/* ================= PORTAL MENU ================= */}
          {menuState &&
            ReactDOM.createPortal(
              <>
                {/* MENU */}
                <div
                  className="action-menu"
                  onMouseDown={(e) => e.stopPropagation()}
                  style={{
                    position: "fixed",
                    top: menuState.y + 5,
                    left: menuState.x - 180,
                    zIndex: 9999
                  }}
                >
                  {designRequests[menuState.index]?.assignedUsername ? (
                    <button
                      onClick={() => {
                        releaseTakeCharge(designRequests[menuState.index], menuState.index);
                        setMenuState(null);
                      }}
                    >
                      Annulla presa in carico
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        takeInCharge(designRequests[menuState.index], menuState.index);
                        setMenuState(null);
                      }}
                    >
                      Prendi in carico
                    </button>
                  )}

                  <button
                    onClick={() => {
                      setOpenNotesIndex(menuState.index);
                      setNotesDraft(designRequests[menuState.index].internalNotes || "");
                      setMenuState(null);
                    }}
                  >
                    Inserisci nota
                  </button>
                  <button
                    disabled={savingNotConcluded}
                    onClick={() => toggleNotConcluded(designRequests[menuState.index])}
                  >
                    {designRequests[menuState.index]?.notConcluded ? "Riattiva richiesta" : "Segna come non concluso"}
                  </button>
                </div>
              </>,
              document.body
            )
          }

          {/* ================= NOTES PORTAL ================= */}
          {openNotesIndex !== null &&
            ReactDOM.createPortal(
              <div
                className="notes-panel"
                onMouseDown={(e) => e.stopPropagation()}
                style={{
                  position: "fixed",
                  top: "20%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 10000
                }}
              >
                <div className="notes-title">Note interne</div>

                <textarea
                  className="notes-textarea"
                  value={notesDraft}
                  onChange={(e) => setNotesDraft(e.target.value)}
                />

                <div className="notes-actions">
                  <button
                    className="btn-save"
                    onClick={() => saveNotes(designRequests[openNotesIndex], openNotesIndex)}
                    disabled={savingNotes}
                  >
                    {savingNotes ? "Salvataggio..." : "Salva"}
                  </button>

                  <button
                    className="btn-cancel"
                    onClick={() => setOpenNotesIndex(null)}
                  >
                    Chiudi
                  </button>
                </div>
              </div>,
              document.body
            )
          }

      {/* =========================
          PAGINATION UI
      ========================= */}
      <div
        style={{
          marginTop: 25,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 8,
          userSelect: "none",
        }}
      >

        {/* PREV */}
        <button
          onClick={goPrev}
          disabled={page === 0}
          style={{
            padding: "6px 10px",
            borderRadius: 6,
            cursor: page === 0 ? "not-allowed" : "pointer",
            opacity: page === 0 ? 0.4 : 1,
          }}
        >
          {"<"}
        </button>

        {/* NUMERI PAGINA */}
        {getPagination(page, totalPages).map((p, i) => (
          <button
            key={i}
            onClick={() => typeof p === "number" && fetchRequests(p - 1)}
            disabled={p === "..."}
            style={{
              padding: "6px 10px",
              borderRadius: 6,
              cursor: p === "..." ? "default" : "pointer",

              backgroundColor: p === page + 1 ? "#111" : "transparent",
              color: p === page + 1 ? "#fff" : "#000",
              fontWeight: p === page + 1 ? "bold" : "normal",
              border: "1px solid #ccc",
              minWidth: 35,
            }}
          >
            {p}
          </button>
        ))}

        {/* NEXT */}
        <button
          onClick={goNext}
          disabled={page + 1 >= totalPages}
          style={{
            padding: "6px 10px",
            borderRadius: 6,
            cursor: page + 1 >= totalPages ? "not-allowed" : "pointer",
            opacity: page + 1 >= totalPages ? 0.4 : 1,
          }}
        >
          {">"}
        </button>

      </div>

    </div>
  );
}

export default DesignRequestsPage;
